<template>
  <roe-error-message :field="design.auto_enrollment_applies_prior_employees">
    <roe-radio-input
      v-model="design.$model.auto_enrollment_applies_prior_employees"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import { AutoEnrollmentMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeAutoEnrollmentAppliesPriorEmployeesRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [AutoEnrollmentMixin],
  props: {
    design: Object
  }
};
</script>
